import { Notice } from '@studio/design-system/notification';
import type { ReactElement } from 'react';
import { BridgeLinkingRequestActions } from '@studio/design-system/notification/notice/actions';
import { Column, Exhibit } from './styled.jsx';

/** `<Notifications>` exhibit. */
export const Notifications = (): ReactElement => (
  <Exhibit title='Notifications'>
    <div className='flex gap-40'>
      {['dark', 'light'].map((theme) => (
        <Column className='w-[400px] bg-white/5' data-theme={theme} key={theme}>
          <Notice closeable={false} notification={{ id: 1, message: 'Message only.' }} unRead />

          <Notice
            notification={{
              id: 1,
              message: '',
              title: 'Bridge Linking Request'
            }}
            actions={<BridgeLinkingRequestActions userEmail='testuser@tryiris.ai' />}
          />

          <Notice
            notification={{
              id: '2',
              message: 'Message only + closeable.',
              severity: 'warning'
            }}
          />

          <Notice
            notification={{
              id: 'thr33',
              message: 'This is an error message.',
              severity: 'error',
              title: 'Error, Yo!'
            }}
          />

          <Notice
            notification={{
              id: 4,
              message:
                /* cspell:disable-next-line */
                'Sit sunt eiusmod consequat officia culpa deserunt ea reprehenderit voluptate. Sunt labore adipisicing duis fugiat. Cillum nostrud enim nostrud dolor ipsum consequat.',
              severity: 'success',
              title: 'Happy Days are Here!'
            }}
          />
        </Column>
      ))}
    </div>
  </Exhibit>
);
